/* Sibling navigation only. Native variants, pricing and cart stay with Shopify. */
(() => {
  if (window.vorugFamilyNavigationMounted) return;
  window.vorugFamilyNavigationMounted = true;
  const productCache = new Map();
  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  let navigating = false;
  let navigationBusy = null;

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    navigating = false;
    navigationBusy?.finishLoading?.();
    if (navigationBusy?.link.getAttribute('aria-busy') === 'true') {
      if (navigationBusy.previous === null) navigationBusy.link.removeAttribute('aria-busy');
      else navigationBusy.link.setAttribute('aria-busy', navigationBusy.previous);
    }
    navigationBusy = null;
  });

  function destination(link) {
    const target = new URL(link.href, location.origin);
    const current = new URL(location.href);
    previewKeys.forEach((key) => {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    return target;
  }

  function hydrate(root) {
    root.querySelectorAll('[data-vorug-family-kind]').forEach((link) => {
      link.href = destination(link).href;
    });
  }

  function publicProduct(handle) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}products/${encodeURIComponent(handle)}.js`, location.origin);
    if (!productCache.has(url.href)) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000);
      productCache.set(url.href, fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        }).finally(() => clearTimeout(timeout)));
    }
    return productCache.get(url.href);
  }

  function optionName(option) {
    return String(typeof option === 'string' ? option : option.name).trim().toLowerCase();
  }

  async function compatibleColorVariant(link, currentProductId, selectedVariantId) {
    if (!selectedVariantId) return null;
    const handle = location.pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return null;
    const [source, target] = await Promise.all([publicProduct(decodeURIComponent(handle)), publicProduct(link.dataset.targetHandle)]);
    if (String(source.id) !== String(currentProductId) || String(target.id) !== String(link.dataset.targetId)) return null;
    const selected = source.variants.find((variant) => String(variant.id) === String(selectedVariantId));
    if (!selected) return null;
    const values = new Map(source.options.map((option, index) => [optionName(option), selected.options[index]]));
    if (source.options.length !== target.options.length || values.size !== target.options.length) return null;
    const matches = target.variants.filter((variant) => variant.available === true && Number(variant.price) > 0 && target.options.every((option, index) => values.has(optionName(option)) && values.get(optionName(option)) === variant.options[index]));
    return matches.length === 1 ? matches[0].id : null;
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('[data-vorug-family-kind]');
    if (!link || !link.closest('.main-product') || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const group = link.closest('[data-vorug-family-options]');
    const drawer = document.querySelector('mto-purchase-drawer');
    if (link.getAttribute('aria-current') === 'true' || drawer?.cartPending || navigating) {
      event.preventDefault();
      return;
    }
    const target = destination(link);
    if (target.origin !== location.origin) return;
    event.preventDefault();
    navigating = true;
    const navigation = { link, previous: link.getAttribute('aria-busy'), finishLoading: window.VorugLoading?.begin?.() };
    navigationBusy = navigation;
    link.setAttribute('aria-busy', 'true');
    target.searchParams.delete('variant');
    if (link.dataset.vorugFamilyKind === 'color') {
      const selected = drawer ? (drawer.state?.selectionMode === 'preset' ? drawer.selectedVariant?.value : null) : new URL(location.href).searchParams.get('variant');
      try {
        const variant = await compatibleColorVariant(link, group.dataset.productId, selected);
        if (variant) target.searchParams.set('variant', variant);
      } catch (_) {
        // A normal sibling page remains a working link if option lookup fails.
      }
    }
    // A shape uses its own native chooser and never reuses another shape's variant ID.
    if (navigationBusy !== navigation) { navigation.finishLoading?.(); return; }
    try {
      location.assign(target.href);
    } catch (error) {
      navigation.finishLoading?.();
      navigating = false;
      if (navigation.previous === null) link.removeAttribute('aria-busy');
      else link.setAttribute('aria-busy', navigation.previous);
      navigationBusy = null;
      throw error;
    }
  });

  function mount() {
    const root = document.querySelector('.main-product');
    if (!root) return;
    const fallback = document.querySelector('[data-vorug-family-fallback]');
    if (fallback) {
      root.querySelectorAll('.buy-buttons').forEach((block) => {
        const choices = fallback.firstElementChild?.cloneNode(true);
        if (choices) block.before(choices);
      });
      fallback.remove();
    }
    hydrate(root);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hydrate(node);
      }));
    }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();

